import { createSlice } from '@reduxjs/toolkit';

const CCEmailReducerSlice = createSlice({
    name: 'CCEmailReducer',
    initialState: {
      value:-1,
    },
    reducers: {
      setCCEmailReducer: (state, action) => {
        state.value = action.payload;
      },
    },
  },
);

export const { setCCEmailReducer } = CCEmailReducerSlice.actions;
export default CCEmailReducerSlice.reducer;